import { qsaOptional, qsaRequired } from '@/scripts/core/global'
import { ProductFormGeneric } from '@/scripts/product-form-context/ProductFormGeneric'

export class VariantRadios extends ProductFormGeneric {
	static htmlSelector = 'variant-radios'
	labels: NodeListOf<HTMLLabelElement>
	colorLabels?: NodeListOf<HTMLElement>
	colorOption?: 'option1' | 'option2' | 'option3'

	constructor() {
		super()
		this.labels = qsaRequired<HTMLLabelElement>('label', this)
		this.labels.forEach((label) => {
			label.addEventListener('click', this.onLabelClick.bind(this))
		})
		this.colorLabels = qsaOptional('[data-uc-color-label]', this)
		if (this.colorLabels) {
			const colorOption = this.colorLabels[0].getAttribute('data-uc-color-label')
			if (colorOption === '3') {
				this.colorOption = 'option3'
			} else if (colorOption === '2') {
				this.colorOption = 'option2'
			} else {
				this.colorOption = 'option1'
			}
		}
	}

	onLabelClick(_: Event) {
		window.setTimeout(() => {
			const selectedOptions = this.getSelectedOptions()
			this.getContext().applyVariantSelection(selectedOptions)
		}, 2)
	}

	getSelectedOptions(): string[] {
		const optionNames = this.getContext().optionNames
		if (!optionNames) throw new Error('optionNames not defined')
		return optionNames.map((optionName: string) => {
			const checkedInput = Array.from(
				qsaRequired<HTMLInputElement>(`input[type="radio"][name="${optionName}"]`, this)
			).find((input) => input.checked)
			if (!checkedInput) throw new Error('checkedInput not found')
			return checkedInput.value
		})
	}
}
